import { MenuItem } from './menu.model';
import { getUserManagementMenu, UserContext } from '../../../common';
import { TranslateService } from '@ngx-translate/core';
import { getHeaderMenu } from '../../../shared/core/ui/app-header/menu/header-menu';

export const getMenu: (userContext?: UserContext, translate?: TranslateService) => MenuItem[] = (
  userContext?: UserContext,
  translate?: TranslateService
) => {
  return [...getHeaderMenu(translate)];
};
